var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loader)?_c('div',{attrs:{"id":"app"}},[_c('router-view')],1):_c('div',{staticClass:"init-main"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo}}),_c('h4',{staticClass:"text-white"},[_vm._v("Arus Explorer")])])}
var staticRenderFns = []

export { render, staticRenderFns }